import React from "react";
import "./LoanModuleStatus.css";
import { PiClockBold } from "react-icons/pi";
import { BsCheckCircle, BsDot } from "react-icons/bs";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { LoanStatus } from "../../Helpers/Enums/ApplicationStatus";

export enum iLoanModule {
  Surity = 1,
}

const LoanModuleStatus = ({ statusId, LoanModule, rejectReasons = [] }) => {
  switch (LoanModule) {
    case iLoanModule.Surity:
      switch (statusId) {
        case LoanStatus.LoanModule_SuretyApprovalPending:
          return (
            <div className="reg-status-container reg-status-container-pending">
              <div className="d-flex justify-content-center align-items-center">
                <PiClockBold className="reg-status-icon reg-status-icon-pending mx-2" />
                <span className="reg-status-text reg-status-text-pending">The application status is under approval.</span>
              </div>
            </div>
          );
        case LoanStatus.LoanModule_SuretyAcceptedByMember:
          return (
            <div className="reg-status-container reg-status-container-approved">
              <div className="d-flex justify-content-center align-items-center">
                <BsCheckCircle className="reg-status-icon reg-status-icon-approved mx-2" />
                <span className="reg-status-text reg-status-text-approved">Surety Verification Completed Successfully.</span>
              </div>
            </div>
          );
        case LoanStatus.LoanModule_SuretyRejectedByMember:
          return (
            <div className="reg-status-container reg-status-container-rejected">
              <div className="d-flex justify-content-center align-items-center">
                <AiOutlineCloseCircle className="reg-status-icon reg-status-icon-rejected mx-2" />
                <span className="reg-status-text reg-status-text-rejected">Surety has been rejected</span>
              </div>
            </div>
          );
        case LoanStatus.LoanModule_InvalidSuretyLink:
          return (
            <div className="reg-status-container reg-status-container-rejected">
              <div className="d-flex justify-content-center align-items-center">
                <AiOutlineCloseCircle className="reg-status-icon reg-status-icon-rejected mx-2" />
                <span className="reg-status-text reg-status-text-rejected">Invalid surety approval link</span>
              </div>
            </div>
          );
        default:
          return null;
      }
    default:
      return null;
  }
};

export default LoanModuleStatus;
